import StoreIcons from "components/StoreIcon";
import Image from "next/image";
import { useWebTranslation, Trans } from "translations";
import { Typography } from "ui-kit/Typography";
import { SpeciesEnum } from "../../../../../../__generated__/globalTypes";
import styles from "./AppBanner.module.css";

export const AppBanner = ({
  email,
  species,
}: {
  email?: string | null;
  species: SpeciesEnum;
}) => {
  const { t } = useWebTranslation();
  const { i18n } = useWebTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Image
          alt="QR code"
          src="/images/qrcode.png"
          width={100}
          height={100}
          className={styles.qrCode}
        />
        <div>
          <Typography
            style={{ textTransform: "uppercase" }}
            variant="body3"
            color="navy500"
          >
            <p>
              <strong>{t("app_banner.highlight")}</strong>
            </p>
          </Typography>
          <Typography variant="body1">
            <p>
              <strong>{t("app_banner.title")}</strong>
            </p>
          </Typography>
          <Typography variant="body2">
            <p>
              <strong>{t("app_banner.subtitle")}</strong>
            </p>
          </Typography>
          <Typography>
            <p>
              <Trans
                i18nKey="app_banner.description"
                values={{ email }}
                components={[<strong key="0" />]}
              />
            </p>
          </Typography>
          <div className={styles.appstoreLinks}>
            <StoreIcons />
          </div>
        </div>
      </div>
      <div className={styles.image}>
        <Image
          src={`/images/points-preview/points-preview-${species}-${i18n?.language}.png`}
          alt="The lassie app"
          width={512}
          height={341}
          className={styles.image}
        />
      </div>
    </div>
  );
};
